/**
 * Product Catalogue Review Summary Report
 *
 * Cross-FP summary of Product Catalogue Review metrics - catalogue
 * health, dormant SKUs, composite BOM hygiene, dead-stock exposure.
 */
import BaseReportPage, { ColumnDef } from './BaseReportPage'

const columns: ColumnDef[] = [
  { key: 'fp_code', label: 'FP Code', type: 'text' },
  { key: 'franchise_name', label: 'Franchise Name', type: 'text' },
  { key: 'last_sync_at', label: 'Data Age', type: 'sync_status' },
  { key: 'fp_status', label: 'Status' },
  { key: 'country', label: 'Country', type: 'text' },
  { key: 'products_in_scope', label: 'In scope', type: 'integer' },
  { key: 'active_products', label: 'Active', type: 'integer' },
  { key: 'spl_products', label: 'PWX Std Prod List', type: 'integer' },
  { key: 'spl_pct', label: 'PWX Std Prod List %', type: 'percent' },
  { key: 'dormant_active', label: 'Dormant active', type: 'integer' },
  { key: 'inactive_with_stock', label: 'Inactive w/ stock', type: 'integer' },
  { key: 'variant_groups', label: 'Variant Groups', type: 'integer' },
  { key: 'variants', label: 'Variants', type: 'integer' },
  { key: 'composites', label: 'Composites', type: 'integer' },
  { key: 'composite_empty_bom', label: 'Empty BOM', type: 'integer' },
  { key: 'composite_broken_ref', label: 'Broken BOM refs', type: 'integer' },
  { key: 'dead_stock_rows', label: 'Dead stock rows', type: 'integer' },
  { key: 'dead_stock_value', label: 'Dead stock value', type: 'currency' },
  { key: 'simple_count', label: 'Standard Products', type: 'integer' },
]

export default function ProductCatalogueReviewSummaryReport() {
  return (
    <BaseReportPage
      reportType="product_catalogue_review_summary"
      title="Product Catalogue Review Summary"
      description="Cross-FP summary of Product Catalogue Review metrics - catalogue health, dormant SKUs, composite BOM hygiene, dead-stock exposure."
      filterConfig={{
        showFpSelector: true,
        showFpStatus: true,
        showCountry: true,
        showRegion: true,
        linkFpStatusToSearch: true,
      }}
      columns={columns}
      defaultSortColumn="fp_code"
      enableBulkActions
    />
  )
}
